/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  'skip-forward': {
    width: 32,
    height: 32,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M5 4l10 8-10 8V4zM19 5v14"/>',
  },
});
